import React from "react";
import { Route, Switch } from "react-router-dom";
import RequestLink from "./ResetPassword/RequestLink";
import AuthLayout from "../Common/AuthLayout";

function PasswordReset() {
    return (
        <AuthLayout>
            <Switch>
                <Route exact path='/resetpassword' component={RequestLink} />
            </Switch>
        </AuthLayout>
    )
}

export default PasswordReset;
